import * as React from 'react';
import { match as Match } from 'react-router';
import { dynamicTitles, dynamicTitlesKey, formatMessage } from 'src/api';
import { connect } from 'react-redux';

import './Projects.page.scss';
import ProjectList from 'src/app/Partials/Project/List/ProjectList';
import ProjectDetail from './ProjectsDetail/ProjectDetail';
import ProjectNew from './ProjectsNew/ProjectsNew';
import { ProjectDispatcher } from 'src/app/Container';

import MESSAGES from './Projects.messages';

export interface ProjectsPageProps {
  dispatch: any;
  match: Match<{projectId: string}>;
}

export class ProjectsPagePartial extends React.Component<ProjectsPageProps> {
  componentDidMount() {
    this.assignTitle();
  }

  componentDidUpdate() {
    this.assignTitle();
  }

  public render() {
    return (
      <div className="page-projects-profile">
        {this.hasProjectId && this.projectId ? (
          <>
            {this.projectId === 'new' ? (
              <ProjectNew />
            ) : (
              <>
                <ProjectDispatcher id={this.projectId} />
                <ProjectDetail projectId={this.projectId} />
              </>
            )}
          </>
        ) : (
          <ProjectList />
        )}
      </div>
    );
  }

  private assignTitle() {
    if (this.hasProjectId) {
      if (this.projectId && this.projectId === 'new') {
        this.props.dispatch(dynamicTitles.add({
          key: dynamicTitlesKey.dashboard,
          value: formatMessage(MESSAGES.projectsNewHeadline),
        }));
      }
    } else {
      this.props.dispatch(dynamicTitles.add({
        key: dynamicTitlesKey.dashboard,
        value: formatMessage(MESSAGES.projectsOverviewHeadline),
      }));
    }
  }

  private get projectId(): string | undefined {
    const { match } = this.props;
    return match && match.params && match.params.projectId;
  }

  private get hasProjectId(): boolean {
    return this.projectId ? true : false;
  }
}

export const ProjectsPage = connect()(ProjectsPagePartial);

export default ProjectsPage;